import React from 'react';

class GridGuides extends React.Component {
  constructor(props) {
    super(props);


    // used by React as the component name
    this.displayName = 'GridGuides';
  }


  /**
   * Renders columns
   * @returns {Array<ReactElement>} - An array of ReactElements
   */
  renderColumns() {
    const columnElements = [];

    for (let i = 0; i < this.props.largeColumns; i++) {
      const key = 'grid-guide-' + i;
      let className = 'grid-guide col-guide-1 push-' + i +
        ' large-col-guide-1 large-push-' + i;

      if (i >= this.props.columns) {
        className = 'grid-guide col-guide-1 push-' + i +
          ' large-col-guide-1 large-push-' + i + ' large';
      }

      columnElements.push(
        <div
          className={className}
          key={key}
        >
          <div className='color' />
        </div>
      );
    }

    return columnElements;
  }


  /**
   * Renders component
   * @returns {ReactElement} ReactElement
   */
  render() {
    const columns = this.renderColumns();
    const className = 'component-grid-guides';

    return (
      <section className={className}>
        <div className='guide-container'>
          {columns}
        </div>
      </section>
    );
  }
}


/**
 * Expected propTypes
 * @prop {Number} columns - The number of columns
 * @prop {Number} largeColumns - The number of columns for a large grid
 */
GridGuides.propTypes = {
  columns: React.PropTypes.number,
  largeColumns: React.PropTypes.number,
};


export default GridGuides;



/** WEBPACK FOOTER **
 ** ./assets/js/src/components/GridGuides.jsx
 **/